import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import facebook from '../../../../assets/images/facebook_24px.svg';
import instagram from '../../../../assets/images/instagram_24px.svg';
import mail from '../../../../assets/images/mail_24px.svg';
import pinterest from '../../../../assets/images/pintrest_24px.svg';
import tiktok from '../../../../assets/images/tiktok_24px.svg';
import twitter from '../../../../assets/images/twitter_24.svg';
import whatsapp from '../../../../assets/images/whatsapp_24px.svg';
import youtube from '../../../../assets/images/youtube_24px.svg';
import { Link } from '../../../../components/Footer/components/Links/components/Link/index.js';
import { Container } from '../../../../components/Footer/components/SocialLinks/components/Container.js';
import { NextImage } from '../../../../components/internal/NextImage/NextImage.js';
import { qaId } from '../../../../utils/index.js';
import { FOOTER_QA_ID } from '../../../../utils/qaId.js';
export const SocialLinks = /*#__PURE__*/_styled(({
  links = [],
  ...restProps
}) => {
  const {
    t
  } = useTranslation(['footer']);
  const socialImages = {
    facebook,
    instagram,
    youtube,
    pinterest,
    tiktok,
    whatsapp,
    mail,
    twitter
  };
  return _jsx(Container, {
    ...restProps,
    "data-testid": qaId(FOOTER_QA_ID, 'links', 'social'),
    children: links.map(({
      label,
      url,
      masked = false
    }) => _jsx(Link
    // @ts-expect-error TS(2322) FIXME
    , {
      // @ts-expect-error TS(2322) FIXME
      href: url,
      target: '_blank',
      rel: "noreferrer",
      ariaLabel: t(label),
      masked: masked,
      children: _jsx(NextImage, {
        image: socialImages[label],
        alt: `${label}icon`
      })
    }, label))
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ec55tuk0"
} : {
  target: "ec55tuk0",
  label: "SocialLinks"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlDRyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ25leHQtaTE4bmV4dCc7XG5pbXBvcnQgZmFjZWJvb2sgZnJvbSAnLi4vLi4vLi4vLi4vYXNzZXRzL2ltYWdlcy9mYWNlYm9va18yNHB4LnN2Zyc7XG5pbXBvcnQgaW5zdGFncmFtIGZyb20gJy4uLy4uLy4uLy4uL2Fzc2V0cy9pbWFnZXMvaW5zdGFncmFtXzI0cHguc3ZnJztcbmltcG9ydCBtYWlsIGZyb20gJy4uLy4uLy4uLy4uL2Fzc2V0cy9pbWFnZXMvbWFpbF8yNHB4LnN2Zyc7XG5pbXBvcnQgcGludGVyZXN0IGZyb20gJy4uLy4uLy4uLy4uL2Fzc2V0cy9pbWFnZXMvcGludHJlc3RfMjRweC5zdmcnO1xuaW1wb3J0IHRpa3RvayBmcm9tICcuLi8uLi8uLi8uLi9hc3NldHMvaW1hZ2VzL3Rpa3Rva18yNHB4LnN2Zyc7XG5pbXBvcnQgdHdpdHRlciBmcm9tICcuLi8uLi8uLi8uLi9hc3NldHMvaW1hZ2VzL3R3aXR0ZXJfMjQuc3ZnJztcbmltcG9ydCB3aGF0c2FwcCBmcm9tICcuLi8uLi8uLi8uLi9hc3NldHMvaW1hZ2VzL3doYXRzYXBwXzI0cHguc3ZnJztcbmltcG9ydCB5b3V0dWJlIGZyb20gJy4uLy4uLy4uLy4uL2Fzc2V0cy9pbWFnZXMveW91dHViZV8yNHB4LnN2Zyc7XG5pbXBvcnQgeyBMaW5rIH0gZnJvbSAnLi4vLi4vLi4vLi4vY29tcG9uZW50cy9Gb290ZXIvY29tcG9uZW50cy9MaW5rcy9jb21wb25lbnRzL0xpbmsvaW5kZXguanMnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vLi4vLi4vY29tcG9uZW50cy9Gb290ZXIvY29tcG9uZW50cy9Tb2NpYWxMaW5rcy9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBOZXh0SW1hZ2UgfSBmcm9tICcuLi8uLi8uLi8uLi9jb21wb25lbnRzL2ludGVybmFsL05leHRJbWFnZS9OZXh0SW1hZ2UuanMnO1xuaW1wb3J0IHsgcWFJZCB9IGZyb20gJy4uLy4uLy4uLy4uL3V0aWxzL2luZGV4LmpzJztcbmltcG9ydCB7IEZPT1RFUl9RQV9JRCB9IGZyb20gJy4uLy4uLy4uLy4uL3V0aWxzL3FhSWQuanMnO1xuZXhwb3J0IGNvbnN0IFNvY2lhbExpbmtzID0gc3R5bGVkKCh7IGxpbmtzID0gW10sIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbihbJ2Zvb3RlciddKTtcbiAgICBjb25zdCBzb2NpYWxJbWFnZXMgPSB7XG4gICAgICAgIGZhY2Vib29rLFxuICAgICAgICBpbnN0YWdyYW0sXG4gICAgICAgIHlvdXR1YmUsXG4gICAgICAgIHBpbnRlcmVzdCxcbiAgICAgICAgdGlrdG9rLFxuICAgICAgICB3aGF0c2FwcCxcbiAgICAgICAgbWFpbCxcbiAgICAgICAgdHdpdHRlcixcbiAgICB9O1xuICAgIHJldHVybiAoX2pzeChDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCBcImRhdGEtdGVzdGlkXCI6IHFhSWQoRk9PVEVSX1FBX0lELCAnbGlua3MnLCAnc29jaWFsJyksIGNoaWxkcmVuOiBsaW5rcy5tYXAoKHsgbGFiZWwsIHVybCwgbWFza2VkID0gZmFsc2UgfSkgPT4gKF9qc3goTGlua1xuICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIFRTKDIzMjIpIEZJWE1FXG4gICAgICAgICwgeyBcbiAgICAgICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgVFMoMjMyMikgRklYTUVcbiAgICAgICAgICAgIGhyZWY6IHVybCwgdGFyZ2V0OiAnX2JsYW5rJywgcmVsOiBcIm5vcmVmZXJyZXJcIiwgYXJpYUxhYmVsOiB0KGxhYmVsKSwgbWFza2VkOiBtYXNrZWQsIGNoaWxkcmVuOiBfanN4KE5leHRJbWFnZSwgeyBpbWFnZTogc29jaWFsSW1hZ2VzW2xhYmVsXSwgYWx0OiBgJHtsYWJlbH1pY29uYCB9KSB9LCBsYWJlbCkpKSB9KSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */");